
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reset-password/request",
      function () {
        return require("private-next-pages/reset-password/request.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reset-password/request"])
      });
    }
  